import React from 'react';
import { useQuery } from 'hooks/apollo';
import { List, Space, Button } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import { gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';

import DistributionStatusTag from 'components/DistributionStatusTag';
import DeviceTypeIcons from 'components/DeviceTypeIcons';

import SurveyTitle from 'components/SurveyTitle';
import messages from './messages';

function getWebsitePreviewLink(url, id) {
  try {
    const parsedUrl = new URL(url);
    parsedUrl.searchParams.append('extellio_debug', true);
    parsedUrl.searchParams.append('extellio_preview', id);
    return parsedUrl.href;
  } catch (e) {
    return '';
  }
}

function popupPreview(url) {
  window.open(
    url,
    '_blank',
    'toolbar=no,scrollbars=yes,resizable=no,top=300,left=500,width=800,height=600',
  );
}

const DistributionListItem = ({ distribution, surveyBaseUrl }) => {
  const getUrl = ({ id }) => `${surveyBaseUrl}d/${id}/?isPreview=true`;

  const actions = [];

  if (distribution.websiteLanguage) {
    actions.push(
      <a href={getWebsitePreviewLink(distribution.websiteLanguage.url, distribution.id)} target="_blank" type="link">
        <EyeOutlined style={{ marginRight: '.5em' }} />
        <FormattedMessage {...messages.previewOn} />
      </a>,
    );
  }

  actions.push(
    <Button size="small" type="link" icon={<EyeOutlined />} onClick={() => popupPreview(getUrl(distribution))}>
      <FormattedMessage {...messages.preview} />
    </Button>,
  );
  return (
    <List.Item
      key={distribution.id}
      extra={<DistributionStatusTag status={distribution.status} />}
      actions={actions}
    >
      <Space direction="vertical">
        <SurveyTitle survey={distribution.survey} />
        <Space>
          <DeviceTypeIcons deviceTypes={distribution.deviceTypes} />
          {distribution.websiteLanguage?.url}
        </Space>
      </Space>
    </List.Item>
  );
};

const DistributionList = ({ distributions }) => {
  const { loading, data } = useQuery(gql`query { config { survey { baseUrl } } }`, { fetchPolicy: 'cache-first' });
  return (
    <List
      itemLayout="vertical"
      dataSource={distributions}
      loading={{ spinning: loading, size: 'large' }}
      renderItem={distribution => <DistributionListItem distribution={distribution} surveyBaseUrl={data?.config?.survey?.baseUrl} />}
    />
  );
};

export default DistributionList;
